// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulp12x7{gap:var(--ds-space-075,6px)}._1bah1h6o{justify-content:center}\n._1bah1yb4{justify-content:space-between}\n._1e0c116y{display:inline-flex}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._4cvr1y6m{align-items:flex-start}\n._4t3i1ul9{height:30px}", ""]);
// Exports
module.exports = exports;
